import NextLink from 'next/link';

import { Icon } from '@playbooks/ui/components/icon';

import type { DocsPage } from 'types/docs';

const DocsPagination = ({ previous, next }: { previous?: DocsPage; next?: DocsPage }) => {
	if (!previous && !next) return null;

	return (
		<nav aria-label='Documentation pagination' className='mt-16 grid gap-4 border-t pt-8 sm:grid-cols-2'>
			{previous ? (
				<NextLink href={previous.href} className='docs-pagination-link items-start text-left'>
					<span className='flex-start gap-1.5 text-xs text-foreground-body'>
						<Icon type='far' icon='chevron-left' aria-hidden /> Previous
					</span>
					<span className='text-sm font-medium'>{previous.title}</span>
				</NextLink>
			) : (
				<span />
			)}
			{next && (
				<NextLink href={next.href} className='docs-pagination-link items-end text-right'>
					<span className='flex-start gap-1.5 text-xs text-foreground-body'>
						Next <Icon type='far' icon='chevron-right' aria-hidden />
					</span>
					<span className='text-sm font-medium'>{next.title}</span>
				</NextLink>
			)}
		</nav>
	);
};

export { DocsPagination };
